/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * On-device signals the scan checks for one target.
 */
export type AiScanTargetSignatures = {
  /**
   * Bare command names resolved on the device PATH; never a path.
   */
  binaries: Array<string>;
  /**
   * macOS CFBundleIdentifier values matched against app bundles under /Applications and ~/Applications.
   */
  bundleIds: Array<string>;
  /**
   * Directories whose existence marks the tool as installed, taken as home-relative unless they start with /. A `*` is a wildcard matching any run of characters within ONE path segment, never crossing a `/`, for tools installed under a version-stamped directory name such as an editor extension.
   */
  configDirs: Array<string>;
  /**
   * Exact process names checked for the running signal.
   */
  processNames: Array<string>;
};

/** @internal */
export const AiScanTargetSignatures$inboundSchema: z.ZodMiniType<
  AiScanTargetSignatures,
  unknown
> = z.pipe(
  z.object({
    binaries: z.array(z.string()),
    bundle_ids: z.array(z.string()),
    config_dirs: z.array(z.string()),
    process_names: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bundle_ids": "bundleIds",
      "config_dirs": "configDirs",
      "process_names": "processNames",
    });
  }),
);
/** @internal */
export type AiScanTargetSignatures$Outbound = {
  binaries: Array<string>;
  bundle_ids: Array<string>;
  config_dirs: Array<string>;
  process_names: Array<string>;
};

/** @internal */
export const AiScanTargetSignatures$outboundSchema: z.ZodMiniType<
  AiScanTargetSignatures$Outbound,
  AiScanTargetSignatures
> = z.pipe(
  z.object({
    binaries: z.array(z.string()),
    bundleIds: z.array(z.string()),
    configDirs: z.array(z.string()),
    processNames: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      bundleIds: "bundle_ids",
      configDirs: "config_dirs",
      processNames: "process_names",
    });
  }),
);

export function aiScanTargetSignaturesToJSON(
  aiScanTargetSignatures: AiScanTargetSignatures,
): string {
  return JSON.stringify(
    AiScanTargetSignatures$outboundSchema.parse(aiScanTargetSignatures),
  );
}
export function aiScanTargetSignaturesFromJSON(
  jsonString: string,
): SafeParseResult<AiScanTargetSignatures, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AiScanTargetSignatures$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AiScanTargetSignatures' from JSON`,
  );
}
